import { useId } from "react";

type ScaleQuestionProps = {
  label: string;
  value: number;
  lowLabel?: string;
  highLabel?: string;
  onChange: (value: number) => void;
};

export function ScaleQuestion({
  label,
  value,
  lowLabel = "完全不同意",
  highLabel = "完全同意",
  onChange
}: ScaleQuestionProps) {
  const groupId = useId();

  return (
    <div className="scale-question" role="group" aria-labelledby={groupId}>
      <p id={groupId} className="scale-q-label">{label}</p>
      <div className="scale-track-wrap">
        <div className="scale-track-line" aria-hidden="true" />
        <div className="scale-dots">
          {Array.from({ length: 7 }, (_, i) => {
            const score = i + 1;
            const selected = score === value;
            return (
              <button
                key={score}
                type="button"
                className={`scale-dot${selected ? " selected" : ""}`}
                aria-pressed={selected}
                aria-label={`${score} 分`}
                onClick={() => onChange(score)}
              >
                {score}
              </button>
            );
          })}
        </div>
      </div>
      <div className="scale-poles">
        <span>{lowLabel}</span>
        <span>{highLabel}</span>
      </div>
    </div>
  );
}
